import { z } from "zod";

/**
 * Promotional discount codes (e.g. event or campaign)
 */
export const DiscountSchema = z.object({
  /** Discount code string */
  code: z.string().optional().describe("Promotional discount code"),

  /** When the discount expires */
  expiration_date: z.date().optional().describe("Expiration date of the discount"),

  /** Discount amount (could be percentage or fixed amount) */
  amount: z.number().int().min(0).optional().describe("Discount amount"),

  /** Current status of the discount */
  status: z.string().optional().describe("Status of the discount (active, expired, used, etc.)"),
});

export type Discount = z.infer<typeof DiscountSchema>;
